import { Button, Flex, Text } from '@chakra-ui/react';
import * as React from 'react';
import { useFormState } from 'react-hook-form';
import { TextInput } from '@lon/mathnation-suit/components';
import { useQueryParams } from '@lon/mathnation-suit/hooks';

const PasswordForm: React.FC<{ onForgot(): void }> = ({ onForgot }) => {
  const [params, setParams] = useQueryParams();
  const { isSubmitting } = useFormState();

  return (
    <>
      <Text as="h2" fontSize="lg" fontWeight="bold" mb={6}>
        Welcome! Please log in to your account.
      </Text>

      <TextInput
        isRequired
        name="username"
        label="Username"
        placeholder="Enter your username"
        inputLayoutProps={{ mt: '4' }}
      />
      <TextInput
        isRequired
        type="password"
        name="password"
        label="Password"
        placeholder="Enter your password"
        inputLayoutProps={{ mt: '4' }}
      />

      <Flex mt={4} justifyContent="space-between">
        <Button
          variant="link"
          colorScheme="blue"
          _hover={{ textDecoration: 'none !important' }}
          onClick={() => setParams({ ...params, state: null, district: null })}
        >
          Change district
        </Button>

        <Flex gridGap={4}>
          <Button
            variant="link"
            onClick={onForgot}
            colorScheme="blue"
            textDecoration="underline"
          >
            Forgot Password?
          </Button>
          <Button
            colorScheme="blue"
            type="submit"
            isLoading={isSubmitting}
            variant="solid"
          >
            Log In
          </Button>
        </Flex>
      </Flex>
    </>
  );
};

export default PasswordForm;
